<app-barra-consulta *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()"
  [exibirNovo]="exibirBotaoNovo" [exibirBotaoAjuda]="exibirBotaoAjuda" [exibirBarraCor]="exibirBarraCor"
  [exibirBotaoDefinirFiltros]="exibirBotaoDefinirFiltros">
</app-barra-consulta>
<app-loading [exibir]="carregando"></app-loading>

<div *ngIf="!carregando">
  <div  *ngIf="removeSelecionado.length != 0">
    <button translate type="button" class="btn btn-primary mr-1 alteracao" (click)="RemoverSelecionados();">
      {{'parametros.moeda.excluirSelecionados'}}
    </button>
   </div>
  <div class="conteudo">

    <p-table #dt dataKey="id" [value]="moedaDados" selectionMode="single" styleClass="p-datatable-responsive-demo
      p-datatable-striped p-datatable-sm" [columns]="selectedColumns" [paginator]="true" [rows]="12" [columns]="cols"
      currentPageReportTemplate="{{'relatorioVeiculos.veiculoVendido.mostrandoRegistros' | translate}}" [value]="rows"
      [autoLayout]="true" id="excel-table" [rowsPerPageOptions]="[10,20,30,50,100]" [showCurrentPageReport]="true">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col style="width:15px">
        </colgroup>
      </ng-template>
      <!-- <ng-template pTemplate="caption">
        <div class="row">
          <div class="col-8">
            <div class="table-header">
              <span class="p-input-icon-left mr-1">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                  placeholder="{{'relatorioVeiculos.veiculoVendido.filtroGeral' | translate}}" />
              </span>

              <p-multiSelect (click)="ocultaFooter()" [options]="cols" [(ngModel)]="selectedColumns"
                optionLabel="header"
                selectedItemsLabel="{{'businessIntelligence.dashboard.colunasSelecionadas' | translate}}"
                [style]="{minWidth: '200px'}"
                placeholder="{{'businessIntelligence.dashboard.colunasSelecionadasPlaceHolder' | translate}}">
              </p-multiSelect>
            </div>
          </div>

        </div>
      </ng-template> -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th [translate]="getTranslate(col.header)" class="text-left percentual" [pSortableColumn]="col.field" *ngFor="let col of columns"
            style="background-color:black;color:white;">
            {{col.header}}
            <em class="fa fa-sort fa-xs float-right" field="col.field" *ngIf="col.field !== 'detalhe' && col.field !== 'remover'"></em>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td class="text-left percentual" *ngFor="let col of columns">
            <div *ngIf="col.field === 'detalhe'">
              <button class="btn btn-ver" (click)="visualizar(dados)" title="Ver Detalhes">
                <i class="far fa-file-alt" style="cursor: pointer;"></i>
              </button>
            </div>
            <div *ngIf="col.field === 'remover'">
              <input type="checkbox" id="removerSelecionados" name="remove" (change)="marcarRemoverSelecionados(dados)" >
            </div>
            <div>
                {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field] }}
              <!-- <ng-container *ngIf="col.field === 'codigoDealer'" [translate]="getTranslate(dados)">
                  </ng-container> -->
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        <p-button type="button" styleClass="p-button-text"></p-button>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <p-button type="button" styleClass="p-button-text"></p-button>
      </ng-template>
    </p-table>
  </div>
</div>
